/**
 * Does this page is rendered in the browser ?
 *
 * @param props - Props passed to the page
 * @returns True if the page is rendered in the browser
 */
export function isClient(): boolean {
  return !process.env.SSR;
}
